import { SafeJSON } from './../../shared/safe-json';
import { Parent } from './../juvenile-case-sections/parent';
import { OtherAllegation } from './../juvenile-case-sections/other-allegations';

export class SupplementalDisposition {
    private json: any;
    private caseIssueId: string;
    private parents: any = [];
    private otherAllegations: any = [];

    private isOrderSupplementalDispositionFlagPresent = false;

    constructor(json: any, caseIssueId: string) {
        this.json = json;
        this.caseIssueId = caseIssueId;
        this.populateParents();
        this.populateOtherAllegations();
    }

    populateParents() {
        let obj: any = SafeJSON.get('parents', this.json);
        let index = '0';
        for (const issue of obj) {
            let value = new Parent(issue, index);
            this.parents.push(value);
        }
    }

    getParents(): any[] {
        this.parents.sort(function (parent1, parent2) {
            return parent1.getPartyName() === parent2.getPartyName() ? 0 : parent1.getPartyName() < parent2.getPartyName() ? -1 : 1;
        });
        return this.parents;
    }

    populateOtherAllegations() {
        let obj: any = SafeJSON.get('allegations', this.json);
        for (const otherAllegation of obj) {
            let allegationId: string = SafeJSON.get('allegationId', otherAllegation);
            if (allegationId !== this.caseIssueId) {
                let value = new OtherAllegation(otherAllegation);
                this.otherAllegations.push(value);
            }
        }
    }


    getOtherAllegations(): any[] {
        return this.otherAllegations;
    }

    getFactsFound(): string {
        return SafeJSON.get('factsFound', this.json);
    }

    getAttendHearings(): string {
        return SafeJSON.get('attendHearings', this.json);
    }

    getAttendHearingsText(): string {
        return SafeJSON.get('attendHearingsText', this.json);
    }

    getProvideTransport(): string {
        return SafeJSON.get('provideTransport', this.json);
    }

    getProvideTransportText(): string {
        return SafeJSON.get('provideTransportText', this.json);
    }

    getHelpJuvenile(): string {
        return SafeJSON.get('helpJuvenile', this.json);
    }

    getHelpJuvenileText(): string {
        return SafeJSON.get('helpJuvenileText', this.json);
    }

    getParentalClasses(): string {
        return SafeJSON.get('parentalClasses', this.json);
    }

    getParentalClassesText(): string {
        return SafeJSON.get('parentalClassesText', this.json);
    }

    getPayTreatment(): string {
        return SafeJSON.get('payTreatment', this.json);
    }

    getPayTreatmentText(): string {
        return SafeJSON.get('payTreatmentText', this.json);
    }

    getParticipateTreat(): string {
        return SafeJSON.get('participateTreat', this.json);
    }

    getParticipateTreatText(): string {
        return SafeJSON.get('participateTreatText', this.json);
    }

    getUndergoEvaluation(): string {
        return SafeJSON.get('undergoEvaluation', this.json);
    }

    getComplyEvaluation(): string {
        return SafeJSON.get('complyEvaluation', this.json);
    }

    getAssumeResp(): string {
        return SafeJSON.get('assumeResp', this.json);
    }

    getAssumeCustody(): string {
        return SafeJSON.get('assumeCustody', this.json);
    }

    getAssumePlacement(): string {
        return SafeJSON.get('assumePlacement', this.json);
    }

    getAssumeFlags(): string {
        let flag = '';

        if (this.getAssumeResp() === 'Y') {
            flag = 'Retain or Assume ';
        }

        if (this.getAssumeCustody() === 'Y') {
            flag = flag + 'legal custody ';
        }

        if (this.getAssumePlacement() === 'Y') {
            flag = flag + 'physical placement';
        }

        if (this.getAssumeResp() === 'Y') {
            // flag = flag + '<br /> ' + this.getAssumeText();
        }

        return flag;
    }

    getAssumeText(): string {
        return SafeJSON.get('assumeText', this.json);
    }

    getPayEvaluation(): string {
        return SafeJSON.get('payEvaluation', this.json);
    }

    getPayEvaluationText(): string {
        return SafeJSON.get('payEvaluationText', this.json);
    }

    getPayExpenses(): string {
        return SafeJSON.get('payExpenses', this.json);
    }

    getPayNCCCOffice(): string {
        return SafeJSON.get('payNCCCOffice', this.json);
    }

    getPayNCCCOfficeAmount(): string {
        return SafeJSON.get('payNCCCOfficeAmount', this.json);
    }

    getPayClerk(): string {
        return SafeJSON.get('payClerk', this.json);
    }

    getPayProbationAmount(): string {
        return SafeJSON.get('payProbationAmount', this.json);
    }

    getPayFacilityAmount(): string {
        return SafeJSON.get('payFacilityAmount', this.json);
    }

    getPayLegalFees(): string {
        return SafeJSON.get('payLegalFees', this.json);
    }

    getLegalFeesDueDate(): string {
        return SafeJSON.get('legalFeesDueDate', this.json);
    }

    getAssignInsurance(): string {
        return SafeJSON.get('assignInsurance', this.json);
    }

    getAssignInsuranceTo(): string {
        return SafeJSON.get('assignInsuranceTo', this.json);
    }

    isOrderDetailsPresent(): boolean {
        let flag = false;

        if ((this.getAttendHearings() !== '') || (this.getAttendHearingsText() !== '') || (this.getProvideTransport() !== '') ||
            (this.getProvideTransportText() !== '') || (this.getHelpJuvenile() !== '') || (this.getHelpJuvenileText() !== '') ||
            (this.getParentalClasses() !== '') || (this.getParentalClassesText() !== '') || (this.getPayTreatment() !== '') ||
            (this.getPayTreatmentText() !== '') || (this.getParticipateTreat() !== '') || (this.getParticipateTreatText() !== '') ||
            (this.getUndergoEvaluation() !== '') || (this.getComplyEvaluation() !== '') || (this.getAssumeResp() !== '') ||
            (this.getAssumeCustody() !== '') || (this.getAssumePlacement() !== '') || (this.getAssumeFlags() !== '') ||
            (this.getAssumeText() !== '') || (this.getPayEvaluation() !== '') || (this.getPayEvaluationText() !== '') ||
            (this.getPayExpenses() !== '') || (this.getPayNCCCOffice() !== '') || (this.getPayNCCCOfficeAmount() !== '') ||
            (this.getPayClerk() !== '') || (this.getPayProbationAmount() !== '') || (this.getPayFacilityAmount() !== '') ||
            (this.getPayLegalFees() !== '') || (this.getLegalFeesDueDate() !== '') || (this.getAssignInsurance() !== '') ||
            (this.getAssignInsuranceTo() !== '')) {
            flag = true;
        }
        return flag;
    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/juvenile/juvenile-case-sections/supplemental-disposition.ts